// extracted by mini-css-extract-plugin
module.exports = {"box":"Input_search_box__3Tsx3","icon":"Input_search_icon__2hF85","button":"Input_search_button__2JTBO"};